import React from 'react';
import './ContactButtonSection.css';
// import { Link } from 'react-router-dom';

const ContactButtonSection = () => {
  return (
    <div className="contact-button-section">
      <div className="button-container">
        <a href="https://lin.ee/4z5c3KI" target="_blank" rel="noopener noreferrer" className="contact-button">
          <h2 className="large-text">LINEで相談</h2>
        </a>
        {/* <Link to="/contact" className="contact-button"> */}
        <a href="https://forms.gle/ZCVbDRcB7TXLSGiM8" target="_blank" rel="noopener noreferrer" className="contact-button">
          <h2 className="large-text">お問い合わせ</h2>
        </a>
        {/* </Link> */}
        <a href="https://forms.gle/64CxJJpewo5kNvmL7" target="_blank" rel="noopener noreferrer" className="contact-button">
          <h2 className="large-text">資料請求</h2>
        </a>
      </div>
    </div>
  );
};

export default ContactButtonSection;